@for (newsItem of newsItems(); track newsItem.id) {
  <a [routerLink]="['/news', newsItem.id]" class="news-link">
    <mat-card class="news-card">
      <img mat-card-image [src]="newsItem.cover_media.thumbnail_url" alt="" />
      <mat-card-header>
        <mat-card-title>{{ newsItem.title }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p class="news-item-teaser">{{ newsItem.teaser }}</p>
      </mat-card-content>
    </mat-card>
  </a>
}
